const styles = theme => ({
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '740px',
    minHeight: '220px',
    paddingTop: '6px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    gap: theme.spacing(2),
  },
  addButton: {
    minWidth: '180px',
  },
  header: {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Inter',
    color: '#000',
    marginLeft: '8px',
  },
})

export default styles
